import React from 'react';
import { Overlay } from '@moda/om';
import { usePayPalButton } from '../../hooks/usePayPalButton';
import { LoadingBalls } from '../LoadingBalls';
import './PayPalButton.scss';

const PAYPAL_BUTTON_ID = 'paypal-button';

const HEIGHTS = {
  small: 32,
  large: 48
};

type Props = {
  size?: 'small' | 'large';
  paypalClientToken: string | null;
  onSelect?: () => Promise<void>;
};

export const PayPalButton: React.FC<Props> = ({ size = 'large', paypalClientToken, onSelect }) => {
  const { loading } = usePayPalButton({
    paypalClientToken,
    elementSelector: `#${PAYPAL_BUTTON_ID}`,
    height: HEIGHTS[size],
    onSubmit: onSelect
  });

  return (
    <div className={`PayPalButton PayPalButton--${size}`}>
      <div id={PAYPAL_BUTTON_ID} data-testid="paypalButton" />
      <Overlay className="PayPalButton__overlay" show={loading}>
        <LoadingBalls />
      </Overlay>
    </div>
  );
};
